import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './assets/index.css';
import App from './App';
import InitialScreen from './InitialScreen';
import * as serviceWorker from './lib/serviceWorker';
import {StoreProvider} from "easy-peasy";
import {configureStore} from "./lib/store";
import { createBrowserHistory } from 'history';

// import i18n (needs to be bundled ;))
import './lib/i18n';

window.fwApp = window.fwApp || {};

window.fwApp.mountDisplayPage = () => {
  const element = document.getElementById("curve-react");
  const dataset = element.dataset;
  const loadingContent = element.innerHTML;
  const history = createBrowserHistory();

  history.listen((location, action) => {
    // location is an object like window.location
    // console.log(action, location.pathname, location.state);
    if (action === "POP") {
      window.location.reload();
    }
  });

  const initialState = {
    endpoint: window.FwApp.baseURL,
    designPoint: {
      flow: parseFloat(dataset.flow),
      pressure: parseFloat(dataset.pressure),
      temperature: parseFloat(dataset.temperature),
      height: parseFloat(dataset.height),
      density: parseFloat(dataset.density),
      density_mode: dataset.densityMode,
      air_max_temperature: parseFloat(dataset.airMaxTemperature),
      frequency: parseFloat(dataset.frequency),
      variant: parseFloat(dataset.variant)
    },
    fan: {
      ...JSON.parse(dataset.fan),
      documentationUrl: dataset.documentationUrl,
    },
    focusedPair: dataset.curve,
    features: dataset.features,
    history: history,
    reportUrl: dataset.reportUrl,
    sections: dataset.sections,
    units: JSON.parse(dataset.units),
    soundDirectionalityOptions: JSON.parse(dataset.soundDirectionalityOptions),
    temperatures: {
      min: undefined,
      max: 200
    },
    customizations: {
      simulationType: "",
      powerLine: JSON.parse(dataset.powerLine),
    },
  };

  const store = configureStore(initialState);

  ReactDOM.render(
    <StoreProvider store={store}>
      <Suspense fallback={<InitialScreen loadingContent={loadingContent} />}>
        <App fan={initialState.fan} designPoint={initialState.designPoint} endpoint={initialState.endpoint} />
      </Suspense>
    </StoreProvider>,
    element
  );

  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://bit.ly/CRA-PWA
  serviceWorker.unregister();
};

if (document.readyState === 'loading') {
  // loading yet, wait for the event
  document.addEventListener('DOMContentLoaded', window.fwApp.mountDisplayPage);
} else {
  // DOM is ready!
  window.fwApp.mountDisplayPage();
}

